import { Field } from 'formik'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LuEye, LuEyeOff } from 'react-icons/lu'
import { inputClass } from './authStyles'

// Campo de contraseña con botón de ojo para mostrar u ocultar lo escrito
export default function PasswordField({ id, name, hasError, autoComplete }) {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const toggleLabel = visible ? t('login.hide_password') : t('login.show_password')

  return (
    <div className="relative mt-2">
      <Field
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        className={`${inputClass(hasError)} pr-10`}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        aria-label={toggleLabel}
        aria-pressed={visible}
        title={toggleLabel}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600 focus:outline-none focus-visible:text-brand"
      >
        {visible ? <LuEyeOff size={18} /> : <LuEye size={18} />}
      </button>
    </div>
  )
}

PasswordField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  autoComplete: PropTypes.string
}

PasswordField.defaultProps = {
  hasError: false,
  autoComplete: 'current-password'
}
